import { Button } from "@ds/react";
import * as S from "./ActionFooter.style";
import GoBackLink from "./GoBackLink";

const ActionFooter = ({ isUrl, primaryLabel, primaryAction, disabled, loading, goBackTo }) => {
  return (
    <S.ActionFooter>
      <Button
        role="button"
        onClick={(e) => {
          primaryAction?.(e);
        }}
        disabled={disabled}
        loading={loading}
        type="submit"
      >
        {primaryLabel}
      </Button>
      <GoBackLink to={goBackTo} isUrl={isUrl} />
    </S.ActionFooter>
  );
};

export default ActionFooter;
